<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2139_10560)">
      <path
        d="M12.0108 7.98933L7.82829 12.1718C7.71994 12.2803 7.59127 12.3664 7.44964
        12.4251C7.30801 12.4838 7.15619 12.514 7.00288 12.514C6.84956 12.514
        6.69774 12.4838 6.55611 12.4251C6.41448 12.3664 6.28581 12.2803
        6.17746 12.1718L1.16663 7.16683V1.3335H6.99996L12.0108 6.34433C12.2281
        6.56292 12.35 6.85861 12.35 7.16683C12.35 7.47505 12.2281 7.77074 12.0108 7.98933Z"
        fill="#7B87A5"
        stroke="#7B87A5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.08337 4.25H4.08921"
        stroke="#F7F8FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2139_10560">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.166748)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
